const redirectStorageKey = "medopilot.auth.returnTo";

export function getCurrentSafeAppPath() {
  const path = `${window.location.pathname}${window.location.search}${window.location.hash}`;
  return sanitizeAppRedirectPath(path) ?? "/app";
}

export function sanitizeAppRedirectPath(value: unknown) {
  if (typeof value !== "string") {
    return null;
  }

  if (!value.startsWith("/app")) {
    return null;
  }

  if (
    value.startsWith("//") ||
    value.includes("://") ||
    value.includes("\\") ||
    [...value].some((char) => char.charCodeAt(0) < 32)
  ) {
    return null;
  }

  try {
    const parsed = new URL(value, window.location.origin);
    if (parsed.origin !== window.location.origin) {
      return null;
    }

    if (parsed.pathname === "/app" || parsed.pathname.startsWith("/app/")) {
      return `${parsed.pathname}${parsed.search}${parsed.hash}`;
    }
  } catch {
    return null;
  }

  return null;
}

export function storeReturnPath(path: string) {
  const safePath = sanitizeAppRedirectPath(path);

  if (!safePath) {
    return;
  }

  window.sessionStorage.setItem(redirectStorageKey, safePath);
}

export function consumeReturnPath(fallback = "/app") {
  const storedPath = window.sessionStorage.getItem(redirectStorageKey);
  window.sessionStorage.removeItem(redirectStorageKey);
  return sanitizeAppRedirectPath(storedPath) ?? fallback;
}

export function clearReturnPath() {
  window.sessionStorage.removeItem(redirectStorageKey);
}
